import axiosConn from '../../axiosConn';
import { parseRadioInvitation, radioNotificationDestination } from '../../utils/radioParticipationUrl';
import { isUnauthorizedError, triggerAuthExpiredRecovery } from '../../utils/authSessionRecovery';
export { parseRadioInvitation } from '../../utils/radioParticipationUrl';

export const RADIO_CONTROLS_EVENT = 'jg:radio:open-controls:v1';
export const RADIO_INVITATION_EVENT = 'jg:radio:invitation:v1';
let pending = null;
const sessions = new Map();

export function openRadioControls(entrySurface = 'capsule') {
  if (!['capsule', 'intake', 'post_submission'].includes(entrySurface)) return;
  window.dispatchEvent(new CustomEvent(RADIO_CONTROLS_EVENT, { detail: { entrySurface } }));
}

export async function captureRadioInteraction({ entrySurface, trackId = '', invitation = '', playerToken, returnTo }) {
  if (!playerToken) { pending = null; return null; }
  const candidate = { token: playerToken, trackId, at: Date.now(), reference: null };
  pending = candidate; // Latest explicit interaction wins, never an arrival/refetch.
  try {
    const response = await axiosConn.post('hitlab/radio/participation-interactions', {
      entrySurface, trackId, invitation,
      requestId: `interaction:${Date.now()}:${Math.random().toString(36).slice(2)}`,
    }, { headers: { Authorization: `Bearer ${playerToken}` }, skipAuthExpiredRecovery: Boolean(returnTo) });
    if (pending !== candidate) return null;
    candidate.reference = response?.data?.data?.reference || null;
    return candidate.reference;
  } catch (error) {
    if (returnTo && parseRadioInvitation(returnTo)?.capsule && isUnauthorizedError(error)) {
      triggerAuthExpiredRecovery({ source: 'Radio invitation', returnTo });
    }
    return null;
  }
}

export function consumeRadioInteraction(playerToken, trackId, startReason) {
  // Interaction evidence is client-reported. Only a fresh explicit Play may
  // bind it; automatic advance and resume leave pending evidence unconsumed.
  if (startReason !== 'explicit') return undefined;
  const value = pending;
  pending = null;
  if (!value || value.token !== playerToken || Date.now() - value.at > 86400000 ||
      (value.trackId && value.trackId !== trackId)) return undefined;
  return value.reference || undefined;
}
export function clearRadioInteraction() { pending = null; sessions.clear(); }
export function clearPendingRadioInteraction() { pending = null; }
export function rememberRadioSession(token, trackId, sessionId) {
  if (!token) return;
  sessions.set(trackId, { token, sessionId });
  if (sessions.size > 24) sessions.delete(sessions.keys().next().value);
}
export function radioOutcomeSession(token, trackId) {
  const value = sessions.get(trackId);
  return value?.token === token ? value.sessionId : undefined;
}

// Synchronous acknowledgement means an actual mounted owner handled the click.
export function presentRadioInvitation(value) {
  const intent = parseRadioInvitation(value);
  if (!intent) return false;
  const detail = { ...intent, accepted: false };
  window.dispatchEvent(new CustomEvent(RADIO_INVITATION_EVENT, { detail }));
  return detail.accepted;
}

export function openRadioNotification(value, history) {
  const destination = radioNotificationDestination(value);
  if (!destination) return false;
  const detail = { ...parseRadioInvitation(destination), accepted: false, preserveRoute: false };
  window.dispatchEvent(new CustomEvent(RADIO_INVITATION_EVENT, { detail }));
  if (!detail.accepted) {
    // A public player or open participation dialog must not be destroyed.
    if (detail.preserveRoute) window.open(destination, '_blank', 'noopener');
    else history.push(destination);
  }
  return true;
}
